const Mobile_data = [
    {
        id : 1,
        img : '../Image/iqoo.webp',
        name : 'iqoo',
        price : 18000,
        color : 'blue'
    },
    {
        id : 2,
        img : '../Image/motoRola.webp',
        name : 'motoRola',
        price : 21500,
        color : 'yellow-blue'
    },
    {
        id : 3,
        img : '../Image/onePlusnord.webp',
        name : 'one plus Nord',
        price : 25000,
        color : 'black'
    },
    {
        id : 4,
        img : '../Image/pocof5.webp',
        name : 'poco f5',
        price : 12399,
        color : 'white'
    },
    {
        id : 5,
        img : '../Image/realme11.webp',
        name : 'realme 11',
        price : 8799,
        color : 'dark-gray'
    },
    {
        id : 6,
        img : '../Image/realme11+.webp',
        name : 'realme 11 plus',
        price : 10999,
        color : 'blue-yellow'
    },
    {
        id : 7,
        img : '../Image/realmec55.webp',
        name : 'realme 55',
        price : 13999,
        color : 'black'
    },
    {
        id : 8,
        img : '../Image/samsung.webp',
        name : 'samsung gallaxy',
        price : 16999,
        color : 'green'
    },
    {
        id : 9,
        img : '../Image/vivotx.webp',
        name : 'vivotx',
        price : 11899,
        color : 'white'
    },
    {
        id : 10,
        img : '../Image/xiame.webp',
        name : 'Xiame',
        price : 14599,
        color : 'black'
    },
]

export default Mobile_data;